module.exports = __webpack_public_path__ + "img/calcom.5abc9e3c.jpg";